<!-- ========== Left Sidebar Start ========== -->


<ng-template #contentTemplate>

  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul class="metismenu list-unstyled" id="side-menu" #sideMenu>




      <li><a  class="side-nav-link-ref" routerLink="/videos/addMulti"> <i class="mdi mdi-24px mdi-plus"></i> {{GetWordText('uploadTitle')}} </a></li>
      <li><a  class="side-nav-link-ref" routerLink="/videos/addMultiNone"> <i class="mdi mdi-24px mdi-plus"></i> {{GetWordText('addMultiNone')}} </a></li>
      <li><a  class="side-nav-link-ref" routerLink="/videos/all">  <i class="mdi mdi-24px mdi-eye-check"></i>{{GetWordText('waiting')}} </a></li>
      <li><a  class="side-nav-link-ref" routerLink="/videos/noname">  <i class="mdi mdi-24px mdi-eye-check"></i>{{GetWordText('waitingNoName')}} </a></li>
      <li><a  class="side-nav-link-ref" routerLink="/videos/accepted"> <i class="mdi mdi-24px mdi-check"></i> {{GetWordText('accepted')}} </a></li>
      <li><a  class="side-nav-link-ref" routerLink="/videos/rejected"> <i class="mdi mdi-24px mdi-close"></i> {{GetWordText('rejected')}} </a></li>
      <li><a  class="side-nav-link-ref" routerLink="/videos/waiting"> <i class="mdi mdi-24px mdi-watch"></i> {{GetWordText('waitingrename')}} </a></li>



    </ul>





  </div>
</ng-template>
<!-- Sidebar -->

<div class="vertical-menu">
  <ngx-simplebar class="h-100" #componentRef>
    <div *ngIf="!isCondensed">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
    <div *ngIf="isCondensed">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
  </ngx-simplebar>
</div>
<!-- Left Sidebar End -->
